// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b818cd1a","453":"4f74c3fa","455":"cab07912"}[chunkId] + ".chunk.js";
};